import type { IRoleEnum } from "@interfaces";
import type { IExtendedRouteObject } from "@routes/types.ts";

export const getRoleRoutes = (
  role: IRoleEnum | null,
  routes: IExtendedRouteObject[],
) => {
  return routes
    ?.filter(
      (route) =>
        role === null ||
        (route.permissions === "all"
          ? true
          : route.permissions?.includes(role)) ||
        route.route.path === "/",
    )
    ?.map((route) => route.route);
};
